import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Select } from 'components/FormFields';
import { TopicFiltersWrapper, TopicFilters } from '../StyledComponents';

const DesktopOnly = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileOnly = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

const TopicFiltersContainer = ({
  children,
  topics,
  activeTopic,
  onSelectTopic,
}) => {
  const options = [
    { label: 'All Topics', value: '' },
    ...(topics || []).map((topic) => ({
      label: topic.name,
      value: topic.id,
    })),
  ];

  return (
    <TopicFiltersWrapper>
      <DesktopOnly>
        <TopicFilters>{children}</TopicFilters>
      </DesktopOnly>
      <MobileOnly>
        <Select
          value={activeTopic || ''}
          onChange={(e) => onSelectTopic(e.target.value || null)}
          options={options}
        />
      </MobileOnly>
    </TopicFiltersWrapper>
  );
};

TopicFiltersContainer.propTypes = {
  children: PropTypes.node.isRequired,
  topics: PropTypes.array,
  activeTopic: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelectTopic: PropTypes.func,
};

export default TopicFiltersContainer;
